import { memo } from 'react';
import { FooterIcon } from '~/lib/data-contract';
import styles from './icon-area.module.css';
import { MarketSelector } from '../market-selector/market-selector.component';
import { MediaImage } from '~/shared/components';

type MetaAreaProps = {
    paymentIcons?: FooterIcon[];
    additionalIcons?: FooterIcon[];
    marketSelector?: boolean;
};

export const IconArea = memo(({ paymentIcons, additionalIcons, marketSelector }: MetaAreaProps) => {
    return (
        <div className={styles.root}>
            {marketSelector && <MarketSelector />}
            <div className={styles.imagesWrapper}>
                <div className={styles.imageContainer}>
                    {paymentIcons?.length
                        ? paymentIcons.map((icon, index) => (
                              <MediaImage
                                  alt={icon.image?.alt || ''}
                                  key={`${icon.image?.src || 'icon'}-${index}`}
                                  src={icon.image?.src || ''}
                                  loading="lazy"
                                  width={35}
                                  height={24}
                              />
                          ))
                        : null}
                </div>
                <div className={styles.imageContainer}>
                    {additionalIcons?.length
                        ? additionalIcons.map((icon, index) => (
                              <MediaImage
                                  alt={icon.image?.alt || ''}
                                  key={`${icon.image?.src || 'icon'}-${index}`}
                                  src={icon.image?.src || ''}
                                  loading="lazy"
                                  width={35}
                                  height={24}
                              />
                          ))
                        : null}
                </div>
            </div>
        </div>
    );
});
